/* eslint-disable @next/next/no-img-element */
import React from 'react';
import PropTypes from 'prop-types';

import './app-store-button.scss';

const AppStoreButton = ({ url }) => (
  <a
    className="app-store-button"
    rel="noopener noreferrer"
    target="_blank"
    href={url}
  >
    <img
      src="//www.nerdwallet.com/cdn/DIT/app-store-btn.svg"
      alt="Download from App Store"
      loading="lazy"
    />
  </a>
);

AppStoreButton.propTypes = {
  url: PropTypes.string.isRequired,
};

AppStoreButton.displayName = 'AppStoreButton';

export default AppStoreButton;
